// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"96d899fe","172":"02afc612","372":"4063af55","442":"0d0b9f5a","487":"a75d1af6","788":"36eb2694"}[chunkId] + ".chunk.js";
};